export default __webpack_public_path__ + "static/media/logout_Icon.c97531c4.svg";